// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_weeks_in_month.ts
var e = (e) => {
	let t = new Date(e), n = t.getMonth(), r = new Date(t.getFullYear(), n, 1), i = new Date(t.getFullYear(), n + 1, 0), a = r.getDay(), o = i.getDate();
	return Math.ceil((o + a) / 7);
};
export { e as get_weeks_in_month };

//# sourceMappingURL=get_weeks_in_month.js.map